export default __webpack_public_path__ + "static/media/edit-btn.fb4b61ff.svg";